/**
 * Navegação interna do portal. As rotas /portal* são registradas em
 * router.tsx por outro pacote (W1); a tipagem estrita do TanStack Router só
 * conhece rotas já registradas, então o cast fica isolado AQUI — os
 * componentes navegam por caminhos concretos ('/portal/tickets/123') que o
 * router resolve normalmente em runtime.
 */
import type { ComponentProps } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';

export const portalPath = {
  dashboard: '/portal',
  tickets: '/portal/tickets',
  newTicket: '/portal/tickets/new',
  ticket: (ticketNumber: number) => `/portal/tickets/${ticketNumber}`,
} as const;

type LinkProps = ComponentProps<typeof Link>;

/** <Link> com `to` string livre (rota do portal ainda não tipada aqui). */
export function PortalLink({ to, ...rest }: Omit<LinkProps, 'to'> & { to: string }) {
  return <Link {...rest} to={to as LinkProps['to']} />;
}

/** navigate() com caminho string livre — mesmo racional do PortalLink. */
export function usePortalNavigate(): (to: string) => void {
  const navigate = useNavigate();
  return (to) => {
    void navigate({ to: to as Parameters<typeof navigate>[0]['to'] });
  };
}
